import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { JOIN_ROOM, LEAVE_ROOM, WS_AUTHENTICATE_SUCCESS, WS_CONNECT_SUCCESS, WS_DISCONNECT_SUCCESS, WS_LOGOUT, WS_RECONNECT_SUCCESS, WS_RECONNECTING } from '../actions/constants';
var initialState = {
  connected: false,
  authenticated: false,
  rooms: [],
  countReconnections: 0,
  lastReconnectionTime: 0
};

var websocketReducer = function websocketReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case WS_CONNECT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        connected: true
      });

    case WS_AUTHENTICATE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        authenticated: true
      });

    case WS_LOGOUT:
      return _objectSpread(_objectSpread({}, state), {}, {
        authenticated: false,
        rooms: []
      });

    case WS_RECONNECTING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          connected: false,
          authenticated: false
        });
      }

    case WS_RECONNECT_SUCCESS:
      {
        if (+new Date() - state.lastReconnectionTime < 1000 * 60) return state;
        return _objectSpread(_objectSpread({}, state), {}, {
          connected: true,
          countReconnections: state.countReconnections + 1,
          lastReconnectionTime: +new Date()
        });
      }

    case JOIN_ROOM:
      {
        var payload = action.payload;

        if (state.rooms.findIndex(function (e) {
          return e.room === payload.room;
        }) !== -1) {
          console.warn("!!! ".concat(payload.room, " already joined !!!"));
          return _objectSpread({}, state);
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          rooms: [].concat(_toConsumableArray(state.rooms), [payload])
        });
      }

    case LEAVE_ROOM:
      {
        var room = action.payload.room;
        var rooms = state.rooms.filter(function (e) {
          return e.room !== room;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          rooms: rooms
        });
      }

    case WS_DISCONNECT_SUCCESS:
      return initialState;

    default:
      return state;
  }
};

export default websocketReducer;
//# sourceMappingURL=websocket.js.map